import fetch from 'commons/src/api/fetch';
import getFetchHeaders from 'commons/src/api/getFetchHeaders';
import {
    MqttPublisherConfig,
    MqttPublisherFormValues,
} from '../features/integrations/mqttPublisher/mqttPublisherTypes';

const BASE_PATH = '/mqtt/broker/config';

function buildFormData(values: MqttPublisherFormValues): FormData {
    const fd = new FormData();
    fd.append('name', values.name);
    fd.append('protocol', values.protocol);
    fd.append('host', values.host);
    fd.append('port', String(values.port));
    fd.append('active', String(values.active));
    fd.append('subscribedToAll', String(values.subscribedToAll));
    fd.append('eventTypes', JSON.stringify(values.eventTypes));
    fd.append('locations', JSON.stringify(values.locations));
    fd.append('sensorUnits', JSON.stringify(values.sensorUnits));

    if (values.username) fd.append('username', values.username);
    if (values.password) fd.append('password', values.password);
    if (values.topicTemplate) fd.append('topicTemplate', values.topicTemplate);

    fd.append('authType', values.authType);

    const { clientCertificate, clientKey, caCertificate } = values;
    if (clientCertificate) fd.append('clientCertificate', clientCertificate);
    if (clientKey) fd.append('clientKey', clientKey);
    if (caCertificate) fd.append('caCertificate', caCertificate);

    return fd;
}

export const fetchMqttPublisherConfigs = async (): Promise<{ configs: MqttPublisherConfig[] }> =>
    fetch(BASE_PATH, {
        method: 'GET',
        headers: await getFetchHeaders(),
    });

export const createMqttPublisherConfig = async (formValues: MqttPublisherFormValues): Promise<MqttPublisherConfig> => {
    const formData = buildFormData(formValues);
    const fetchHeaders = await getFetchHeaders();
    return fetch(BASE_PATH, {
        method: 'POST',
        headers: { ...fetchHeaders, 'Content-Type': 'multipart/form-data' },
        body: formData,
    });
};

export const updateMqttPublisherConfig = async (
    clientId: string,
    formValues: MqttPublisherFormValues
): Promise<MqttPublisherConfig> => {
    const formData = buildFormData(formValues);
    const fetchHeaders = await getFetchHeaders();
    return fetch(`${BASE_PATH}/${clientId}`, {
        method: 'PUT',
        headers: { ...fetchHeaders, 'Content-Type': 'multipart/form-data' },
        body: formData,
    });
};

export const deleteMqttPublisherConfig = async (clientId: string): Promise<void> =>
    fetch(`${BASE_PATH}/${clientId}`, {
        method: 'DELETE',
        headers: await getFetchHeaders(),
    });

export const testMqttPublisherConnection = async (clientId: string): Promise<void> =>
    fetch(`${BASE_PATH}/${clientId}/test`, {
        method: 'POST',
        headers: await getFetchHeaders(),
    });
